// react
import PropTypes from "prop-types";
import React from "react";

// utils
import Clamp from "../../utils/Clamp";

// styles
import css from "./Pagination.module.scss";

export default class Slider extends React.Component {
	static propTypes = {
		onDragEnd: PropTypes.func,
		onDragStart: PropTypes.func,
		onChange: PropTypes.func,
		value: PropTypes.number,
		height: PropTypes.number,
		ballSize: PropTypes.number,
		width: PropTypes.number,
	};

	static defaultProps = {
		value: 0,
		height: 6,
		ballSize: 10,
		width: 100,
		onChange: () => {},
		onDragStart: () => {},
		onDragEnd: () => {},
	};

	state = {
		value: 0,
		isDragging: false,
	};

	constructor(props) {
		super(props);

		this.state.value = props.value;
	}

	static getDerivedStateFromProps(nextProps, currentState) {
		if (nextProps.value !== undefined && !currentState.isDragging) {
			return { value: nextProps.value };
		}

		return null;
	}

	onDragStart = () => {
		this.setState({ isDragging: true });

		this.props.onDragStart();
	};

	onDragUpdate = (event) => {
		const position = event.clientX - this.getTrackOffset();

		this.setValueFromPosition(position);
	};

	onDragStop = () => {
		this.setState({ isDragging: false });

		this.props.onDragEnd();
	};

	getTrackOffset = () => this.track.getBoundingClientRect().left;

	setValueFromPosition = (position) => {
		const value = Clamp(position / this.props.width, 0, 1);
		this.setState({ value });

		this.props.onChange(value);
	};

	handleMouseDown = (event) => {
		document.addEventListener("mousemove", this.handleDrag);
		document.addEventListener("mouseup", this.handleMouseEnd);

		// cancel text selection
		event.preventDefault();

		// set focus manually since we call preventDefault
		this.handle.focus();

		this.onDragStart(event);
	};

	handleDrag = (event) => {
		this.onDragUpdate(event, "mouse");
	};

	handleMouseEnd = (event) => {
		document.removeEventListener("mousemove", this.handleDrag);
		document.removeEventListener("mouseup", this.handleMouseEnd);

		this.onDragStop(event);
	};

	render() {
		const { value } = this.state;
		const { height, width, ballSize } = this.props;

		const ballPlacement = (height - ballSize) / 2;
		const ballPositionLeft = value * width;

		return (
			<div className={css.paginationSlider} style={{ height, width }}>
				<div
					ref={(node) => {
						this.track = node;
					}}
					className="sliderTrack"
					style={{ height }}
				>
					<div
						ref={(node) => {
							this.handle = node;
						}}
						onMouseDown={this.handleMouseDown}
						className="sliderBall"
						style={{
							top: ballPlacement,
							left: ballPositionLeft,
							height: ballSize,
							width: ballSize,
						}}
					/>
				</div>
			</div>
		);
	}
}
